import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminNivelesAutorizacionPage } from "@/features/admin-niveles-autorizacion/components/AdminNivelesAutorizacionPage";
import { nivelesAutorizacionQueryOptions } from "@/features/admin-niveles-autorizacion/hooks/use-niveles-autorizacion";
import { areasAdminQueryOptions } from "@/features/admin-areas/hooks/use-areas-admin";
import { rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/**
 * Ruta `/admin/flujos-autorizacion` · niveles agrupados por flujo. Precarga
 * áreas + niveles + roles (para los checkboxes de autorizadores) en paralelo.
 */
export const Route = createFileRoute("/_authed-tw/admin/flujos-autorizacion")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminFlujosAutorizacion])
      ? Promise.all([
      queryClient.ensureQueryData(nivelesAutorizacionQueryOptions),
      queryClient.ensureQueryData(areasAdminQueryOptions),
      queryClient.ensureQueryData(rolesAdminQueryOptions),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminFlujosAutorizacion]}>
      <AdminNivelesAutorizacionPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
